/** Link direto para inspecionar a transação (mainnet). */
export function txExplorerUrl(signature) {
    if (!signature) return '';
    return `https://solscan.io/tx/${signature}`;
}

/**
 * Mensagem amigável em português para erros de carteira / RPC / simulação Solana.
 */
export function formatSolanaError(err) {
    const raw = err?.message || err?.toString?.() || '';
    const fromAxios = err?.response?.data;
    let base = raw;
    if (typeof fromAxios === 'string') base = fromAxios;
    else if (fromAxios && typeof fromAxios === 'object') {
        base = fromAxios.message || fromAxios.error || JSON.stringify(fromAxios);
    }

    const logs = extractSolanaLogs(err);
    const msg = `${String(base || 'Erro desconhecido.').trim()}${logs ? ` Logs: ${logs}` : ''}`;

    if (/wallet.?not connected|not connected to solana/i.test(msg)) {
        return 'Conecte a carteira Solana e tente novamente.';
    }
    if (/user rejected|rejected the request|rejected by user|4001|cancelled|canceled/i.test(msg)) {
        return 'Operação cancelada na carteira.';
    }
    if (/insufficient funds|insufficient lamports|account.*does not have enough|insufficient token|transfer: insufficient|0x1\b/i.test(msg.toLowerCase())) {
        const lower = msg.toLowerCase();
        const looksToken = /spl-token|token program|transfer checked|transfer: insufficient|insufficient token|token account|amount.*exceed/i.test(lower);
        const looksSol = /insufficient lamports|rent|system program|create account|11111111111111111111111111111111/i.test(lower);
        if (looksToken && !looksSol) {
            return 'Saldo insuficiente do token da pool para este depósito. O valor digitado pode ser menor que o máximo exigido pela rede (slippage). '
                + 'Use «Atualizar saldo», reduza o valor ou aumente o slippage e tente de novo.';
        }
        if (looksToken && looksSol) {
            return 'Saldo insuficiente: confira o token da pool (até o máximo com slippage) e também SOL na carteira (~0,03 SOL ou mais para abrir posição nova + taxas).';
        }
        if (/taxa da plataforma|platform fee|fee share/i.test(lower)) {
            return 'Saldo insuficiente do token para a taxa da plataforma (1%) após coletar taxas. '
                + 'Se as taxas já foram coletadas, use «Sacar liquidez» de novo para continuar só o saque.';
        }
        return 'Saldo insuficiente de SOL para taxas de rede e criação da posição (rent). '
            + 'Mantenha SOL na carteira além dos tokens — mesmo com muito ORCA/USDC, abrir posição nova costuma exigir ~0,03 SOL ou mais.';
    }
    if (/0x17b5|PriceSlippageOutOfBounds|price outside slippage bounds/i.test(msg)) {
        return 'Liquidez concentrada: o preço da pool saiu dos limites de slippage ao depositar (PriceSlippageOutOfBounds / 0x17b5). '
            + 'Em liquidez concentrada isto é frequente: 100 bps = 1%. Suba «Slippage (bps)» — por exemplo 2000–6000 (20–60%) em pares voláteis — e envie de novo; '
            + 'a app também re-sincroniza a cotação antes de assinar.';
    }
    if (/slippage|0x1771/i.test(msg.toLowerCase())) {
        return 'A operação falhou por slippage ou preço fora do limite. Aumente a tolerância ou tente de novo.';
    }
    if (/simulation failed|transaction simulation failed/i.test(msg)) {
        const short = msg.length > 420 ? `${msg.slice(0, 420)}…` : msg;
        return `A rede recusou a simulação da transação: ${short}`;
    }
    if (/not confirmed in|transactionexpiredtimeouterror/i.test(msg.toLowerCase())) {
        return 'Tempo esgotado ao aguardar confirmação. Verifique no Explorer se a transação foi processada.';
    }

    return msg.length > 550 ? `${msg.slice(0, 550)}…` : msg;
}

function extractSolanaLogs(err) {
    const logs = err?.logs
        || err?.data?.logs
        || err?.cause?.logs
        || err?.error?.logs
        || err?.response?.data?.logs;
    if (Array.isArray(logs) && logs.length) {
        return logs.slice(-8).join(' | ');
    }
    return '';
}

/**
 * Texto de sucesso após uma ou mais transações confirmadas.
 */
export function buildTxSuccessMessage({
    title,
    signatures = [],
    anyRecoveredAfterTimeout = false,
    suffix = ''
}) {
    const clean = (title || 'Operação concluída.').trim();
    const n = signatures.length;
    let text = clean;
    if (n > 1) {
        text += ` ${n} transações confirmadas na rede.`;
    } else if (n === 1) {
        text += ' Transação confirmada na rede.';
    }
    if (anyRecoveredAfterTimeout) {
        text += ' A confirmação demorou; o status foi verificado de novo na RPC.';
    }
    const last = n ? signatures[n - 1] : '';
    if (last) {
        text += ` Assinatura: ${last}. Explorer: ${txExplorerUrl(last)}`;
    }
    if (suffix) text += ` ${suffix}`;
    return text;
}
